const normalizeNumericString = (value) => {
    if (value === null || value === undefined) {
        return "";
    }

    const stringValue = `${value}`
        .replace(/\u00A0/g, "")
        .replace(/\s/g, "")
        .replace(/'/g, "")
        .replace(/,/g, ".");

    const dotMatches = stringValue.match(/\./g);
    if (!dotMatches || dotMatches.length <= 1) {
        return stringValue;
    }

    const [integerPart, ...decimalCandidates] = stringValue.split(".");
    const decimalPart = decimalCandidates.pop();
    const compactInteger = [integerPart, ...decimalCandidates].join("");
    return `${compactInteger}.${decimalPart}`;
};

const toNumericValue = (value) => {
    const normalized = normalizeNumericString(value);
    if (!normalized) {
        return undefined;
    }
    const numeric = Number(normalized);
    return Number.isNaN(numeric) ? undefined : numeric;
};

const countDecimalPlaces = (value) => {
    if (value === null || value === undefined) {
        return 0;
    }
    const stringValue = `${value}`.replace(/\u00A0/g, "").replace(/\s/g, "");
    const match = stringValue.match(/[\.,](\d+)/);
    return match ? match[1].length : 0;
};

export const formatAmount = (value, options = {}) => {
    const {
        minimumFractionDigits,
        maximumFractionDigits,
        keepDecimalCount = true,
        emptyValue = "",
    } = options;

    if (value === null || value === undefined || value === "") {
        return emptyValue;
    }

    const numericValue = typeof value === "number" ? value : toNumericValue(value);
    if (numericValue === undefined) {
        return emptyValue;
    }

    let minDigits = minimumFractionDigits;
    let maxDigits = maximumFractionDigits;
    if (keepDecimalCount && minDigits === undefined && maxDigits === undefined) {
        const decimalCount = countDecimalPlaces(value);
        if (decimalCount > 0) {
            minDigits = decimalCount;
            maxDigits = decimalCount;
        }
    }

    return new Intl.NumberFormat("fr-FR", {
        useGrouping: true,
        minimumFractionDigits: minDigits,
        maximumFractionDigits: maxDigits,
    }).format(numericValue);
};

export const formatAmountInput = (value) => {
    if (value === null || value === undefined || value === "") {
        return "";
    }
    return formatAmount(value, { emptyValue: "" });
};

export const parseAmount = (value) => {
    if (value === null || value === undefined || value === "") {
        return undefined;
    }
    return toNumericValue(value);
};

export const displayNumbers = (value) => {
    return value && new Intl.NumberFormat('fr-FR').format(Math.floor(value))
};

export const displayNum = (value) => {
    return value && new Intl.NumberFormat('en-DE').format(value).replace(/\./g, ' ')
};

export const displayFloorNum = (value) => {
    return value && new Intl.NumberFormat('en-DE').format(Math.floor(value)).replace(/\./g, ' ')
};


export const toNumber = (value) => {
    const numeric = toNumericValue(value);
    return numeric === undefined ? 0 : numeric;
};
